export default "__VITE_ASSET__BrfIX3jm__"